import { render, staticRenderFns } from "./AddEditRule.vue?vue&type=template&id=44a76066&scoped=true"
import script from "./AddEditRule.vue?vue&type=script&lang=js"
export * from "./AddEditRule.vue?vue&type=script&lang=js"
import style0 from "./AddEditRule.vue?vue&type=style&index=0&id=44a76066&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a76066",
  null
  
)

export default component.exports